webpackJsonp([22,35],{

/***/ 3:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (config) {
	  this.distanceX = 0;
	  this.distanceY = 0;
	  this.startPos = [0, 0];
	  this.currentPos = [0, 0];
	  this.startTime = 0;
	  this.endTime = 0;
	  this.speedX = 0;
	  this.speedY = 0;
	
	  this.state = 'FREE';
	  this.alias = config.alias || '';
	  this.dom = config.dom;
	  this.eventType = config.type || 'swipe';
	  this.callback = config.doing || function () {};
	  this.donecallback = config.done || function () {};
	
	  this.mode = config.mode || 'strict';
	
	  var t = this;
	
	  this.handleTouchStart = function (e) {
	    t.startTime = new Date().getTime();
	    t.state = 'START';
	    var touch = e.targetTouches[0];
	    t.startPos = [touch.pageX, touch.pageY];
	
	    t.callback('touchstart', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.startPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchMove = function (e) {
	    t.state = 'MOVING';
	    var touch = e.targetTouches[0];
	    t.currentPos = [touch.pageX, touch.pageY];
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	    t.callback('touchmove', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.currentPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchEnd = function () {
	    t.state = 'END';
	    t.endTime = new Date().getTime();
	    var time = Math.floor((t.endTime - t.startTime) / 1000);
	
	    if (t.currentPos[0] === 0 || t.currentPos[1] === 0) {
	      t.currentPos = t.startPos;
	    }
	
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	
	    if (time === 0) time = 1;
	    t.speedX = Math.abs(t.distanceX / time);
	    t.speedY = Math.abs(t.distanceY / time);
	
	    if (!t.actions[t.eventType]()) {
	      t.callback('touchend', {
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    } else {
	      if (t.mode === 'unstrict') {
	        t.callback('touchend', {
	          distance: { x: t.distanceX, y: t.distanceY },
	          speed: { x: t.speedX, y: t.speedY },
	          position: t.currentPos,
	          state: t.state,
	          alias: t.alias
	        });
	      }
	
	      t.donecallback({
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    }
	
	    t.state = 'FREE';
	    t.distanceX = 0;
	    t.distanceY = 0;
	    t.startTime = 0;
	    t.endTime = 0;
	    t.speedX = 0;
	    t.speedY = 0;
	    t.startPos = [0, 0];
	    t.currentPos = [0, 0];
	  };
	
	  this.actions = {
	    swipe: function swipe() {
	      return true;
	    },
	    swipeDown: function swipeDown() {
	      if (t.distanceY > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeUp: function swipeUp() {
	      if (t.distanceY < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeLeft: function swipeLeft() {
	      if (t.distanceX < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeRight: function swipeRight() {
	      if (t.distanceX > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeX: function swipeX() {
	      if (Math.abs(t.distanceX) > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeY: function swipeY() {
	      if (Math.abs(t.distanceY) > 60) {
	        return true;
	      }
	      return false;
	    }
	  };
	
	  this.init = function () {
	    this.dom.addEventListener('touchstart', this.handleTouchStart);
	    this.dom.addEventListener('touchmove', this.handleTouchMove);
	    this.dom.addEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.destory = function () {
	    this.dom.removeEventListener('touchstart', this.handleTouchStart);
	    this.dom.removeEventListener('touchmove', this.handleTouchMove);
	    this.dom.removeEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.init();
	};

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(143),
	  /* template */
	  __webpack_require__(282),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slider = __webpack_require__(207);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'sliderdemo',
	  components: {
	    Slider: _slider2.default
	  },
	  created: function created() {},
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _touchit = __webpack_require__(3);
	
	var _touchit2 = _interopRequireDefault(_touchit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'slider',
	  props: {
	    direction: {
	      type: String,
	      default: 'y'
	    },
	    mode: {
	      type: String,
	      default: 'linear' }
	  },
	  mounted: function mounted() {
	    this.touchit = new _touchit2.default({
	      dom: this.$refs.scroll,
	      type: 'swipe',
	      done: this.handleTouchEnd,
	      doing: this.handleTouch
	    });
	  },
	
	  methods: {
	    reachTop: function reachTop() {
	      return this.distanceY >= 0;
	    },
	    reachBottom: function reachBottom() {
	      return this.distanceY <= this.$refs.scroll.clientHeight - this.$refs.content.clientHeight;
	    },
	    reachLeft: function reachLeft() {
	      return this.distance >= 0;
	    },
	    reachRight: function reachRight() {
	      return this.distanceY <= this.$refs.scroll.clientHeight - this.$refs.content.clientHeight;
	    },
	    putRight: function putRight() {
	      if (this.reachTop()) {
	        this.distanceYBackup = 0;
	        this.moveY(-this.distanceYBackup);
	        clearInterval(this.timer);
	        return true;
	      }
	
	      if (this.reachBottom()) {
	        this.moveY(-this.$refs.content.clientHeight + this.$refs.scroll.clientHeight - this.distanceYBackup);
	        clearInterval(this.timer);
	        return true;
	      }
	
	      return false;
	    },
	    moveY: function moveY(distance) {
	      this.distanceY = distance + this.distanceYBackup;
	      this.$refs.content.style.transform = 'translate3d(0px, ' + this.distanceY + 'px, 0px)';
	    },
	    handleTouch: function handleTouch(eventType, data) {
	      switch (eventType) {
	        case 'touchstart':
	          {
	            clearInterval(this.timer);
	            this.distanceYBackup = this.distanceY;
	            break;
	          }
	        case 'touchmove':
	          {
	            this.moveY(data.distance.y);
	            break;
	          }
	        default:
	          {
	            break;
	          }
	      }
	    },
	    handleTouchEnd: function handleTouchEnd(data) {
	      var _this = this;
	
	      if (this.putRight()) return;
	
	      var jump = parseInt(1000 / 100);
	
	      var step = data.speed.y * jump / 1000;
	      var length = this.distanceY - this.distanceYBackup;
	      var everystep = step / 100;
	
	      this.timer = setInterval(function () {
	        if (data.distance.y >= 0) {
	          length += step;
	          _this.moveY(length);
	        } else {
	          length -= step;
	          _this.moveY(length);
	        }
	
	        step -= everystep;
	
	        if (step <= everystep) {
	          clearInterval(_this.timer);
	          _this.distanceYBackup = _this.distanceY;
	        }
	
	        if (_this.putRight()) {
	          clearInterval(_this.timer);
	        }
	      }, jump);
	    }
	  },
	  data: function data() {
	    return {
	      touchit: null,
	      distanceXBackup: 0,
	      distanceYBackup: 0,
	      distanceX: 0,
	      distanceY: 0,
	      timer: null
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.touchit.destory();
	  }
	};

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(144),
	  /* template */
	  __webpack_require__(258),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 258:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "scroll",
	    staticClass: "slider"
	  }, [_c('div', {
	    ref: "content",
	    staticClass: "slider-content"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('slider', {
	    style: ({
	      height: '200px'
	    })
	  }, [_c('div', {
	    staticClass: "p2222"
	  }, [_c('p', [_vm._v("\n        11111111\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        11111111\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        11111111\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        11111111\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        222222222\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        11111111\n      ")])])]), _vm._v(" "), _c('slider', {
	    style: ({
	      height: '100px'
	    })
	  }, [_c('div', {
	    staticStyle: {
	      "width": "1000px",
	      "height": "100px",
	      "text-align": "left"
	    }
	  }, [_vm._v("\nsddsfsdfsdfdsfdssddssdfdsdsfdsfsd\n    ")])])], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/22.66a66edf535bd3dd379c.js